module.exports = __webpack_public_path__ + "media/images/search-button-9345155d8b1fbb9607551346b94a33f3.svg";